"use server";
import "server-only";
import React from "react";
import StoreProvider from "./store/StoreProvider";
import { InjectToast } from "./components/toast/Toast";

interface Props {
  children: React.ReactNode;
}

export default async function NextToolkitProvider({ children }: Props) {
  return (
    <StoreProvider>
      <InjectToast />
      {children}
    </StoreProvider>
  );
}
